import React, { useEffect, useState } from "react";
import ProtectionChannelSpamCalls from "./protection-channel-spam-calls.component";
import ProtectionChannelSpamSMSName from "./protection-channel-spam-sms-name.component";
import Storage from "../../services/storage.service";

export default function ProtectionChannelSpamSMS({
  reportSpamCall = () => {},
  subTypeHasLandlineSubstring = false,
  reportSubType = {},
}) {
  const [, setReportType] = useState("Number");
  const [, setReportTypeList] = useState([]);

  const fraudGenericType = reportSubType?.FraudGenericType || "";

  const reportCallOrSMS = (data) => {
    setReportType(data);
  };
  // useEffect(() => {
  //     prefilledData();
  // }, []);

  const prefilledData = () => {
    let data_payload = JSON.parse(Storage.get("PrePayload"));
    if (data_payload && data_payload?.UserName && data_payload?.Notes) {
      reportCallOrSMS("Sender_name");
    }

    if (
      data_payload &&
      !data_payload?.UserName &&
      !data_payload?.Notes &&
      data_payload?.ReportedMSISDNNo
    ) {
      reportCallOrSMS("Number");
    }
  };
  const renderReportForm = () => {
    let content = null;
    switch (fraudGenericType) {
      case "SenderName":
        content = (
          <ProtectionChannelSpamSMSName reportSpamCall={reportSpamCall} />
        );
        break;
      case "SMS":
      case "LandLine":
      case "International":
        content = (
          <ProtectionChannelSpamCalls
            showMessage={true}
            reportSpamCall={reportSpamCall}
            subTypeHasLandlineSubstring={subTypeHasLandlineSubstring}
            reportSubType={reportSubType}
          />
        );
        break;
      default:
        break;
    }
    return content;
  };

  useEffect(() => {
    getStorageValue("fraud_details_types");
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getStorageValue = (key) => {
    let business = JSON.parse(Storage.get("business", true));
    let poValue = business[key] ? business[key] : "";
    if (poValue) {
      setReportTypeList(poValue.length > 0 ? poValue : []);
      prefilledData();
    } else {
      setReportTypeList([]);
    }
  };

  return <div className="field-section">{renderReportForm()}</div>;
}
